const ogs_betreuung = `${process.env.REACT_APP_BACKEND_URL}/uploads/files/betreuungsvertrag.pdf`;
const stellenanzeige = `${process.env.REACT_APP_BACKEND_URL}/uploads/files/Stellenanzeige_OGS_Oberpleis_v202507.pdf`;
const kursabmeldung = "/service/kursabmeldung";
const anmeldungCamp = "/service/anmeldung-camp";
const mitgliedantragJugendfoerderverein = "/service/mitgliedsantrag-jugendfoerderverein";
const mitgliedantragTuS = "/service/mitgliedsantrag-tus";
const elternbeitragtagesbetreuung = `${process.env.REACT_APP_BACKEND_URL}/uploads/files/5.75c_satzungerhebungelternbeitraegetagesbetreeung_131223.pdf`;
const spendenErklaerung = `${process.env.REACT_APP_BACKEND_URL}/uploads/files/erklaerung_zu_spenden.pdf`;
const jugendschutzkonzept = `${process.env.REACT_APP_BACKEND_URL}/uploads/files/jugendschutzkonzept_tus05_oberpleis_2024.pdf`;
const mitgliederversammlung2024 = `${process.env.REACT_APP_BACKEND_URL}/uploads/files/protokoll_mitgliederversammlung_20240618.pdf`;
const mitgliederversammlung2023 = `${process.env.REACT_APP_BACKEND_URL}/uploads/files/protokoll_mitgliederversammlung_20230613.pdf`;
const mitgliederversammlung2022 = `${process.env.REACT_APP_BACKEND_URL}/uploads/files/protokoll_mitgliederversammlung_20220621.pdf`;
const mitgliederversammlung2021 = `${process.env.REACT_APP_BACKEND_URL}/uploads/files/protokoll_mitgliederversammlung_20210929.pdf`;
const satzung2020 = `${process.env.REACT_APP_BACKEND_URL}/uploads/files/satzung_beschluss_mitgliederversammlung_20200928.pdf`;
const aufnahmeAntragFreundeFoerderer = `${process.env.REACT_APP_BACKEND_URL}/uploads/files/aufnahmeantrag_mitgliedschaft_freunde_und_foerderer.pdf`;
const satzungJugendfoerderverein = `${process.env.REACT_APP_BACKEND_URL}/uploads/files/JFV_satzung_03_2014.pdf`;
const passantragWestdeutscherFussball = `https://wdfv.de/download/spielberechtigungen/spielberechtigungsantrag.pdf`;
const schulministeriumNRW = 'https://www.bildungspartner.schulministerium.nrw.de/de/bildungspartnerschaften/sportverein/sportverein.html';
const nachhaltigkeitsziele = `${process.env.REACT_APP_BACKEND_URL}/uploads/files/Nachhaltigkeitsziele_TuS05Oberpleis_v2025.pdf`;
export {
    ogs_betreuung,
    stellenanzeige,
    kursabmeldung,
    anmeldungCamp,
    mitgliedantragJugendfoerderverein,
    mitgliedantragTuS,
    elternbeitragtagesbetreuung,
    spendenErklaerung,
    jugendschutzkonzept,
    mitgliederversammlung2024,
    mitgliederversammlung2023,
    mitgliederversammlung2022,
    mitgliederversammlung2021,
    satzung2020,
    aufnahmeAntragFreundeFoerderer,
    satzungJugendfoerderverein,
    passantragWestdeutscherFussball,
    schulministeriumNRW,
    nachhaltigkeitsziele
}